import { type PropsWithChildren } from 'react'
import { Stack } from '../../primitives/Stack'
import { useSpacingToken } from '../../theme/hooks/use-spacing-token'
import { useCard } from './use-card'

type Props = PropsWithChildren<{
  noPaddings?: boolean
}>

export const BaseCardFooter = ({ children, noPaddings }: Props) => {
  const spacingToken = useSpacingToken()
  const { isDense, isMobile } = useCard()

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      sx={{
        ...(!noPaddings && {
          px: isDense ? 2 : spacingToken,
          pb: isMobile ? 2 : 2.5,
        }),
        gap: 2,
        justifyContent: 'flex-end',
      }}
    >
      {children}
    </Stack>
  )
}
